import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="glass rounded-3xl p-12 max-w-xl text-center">
        <h1 className="font-display text-4xl text-navy" data-testid="pay-cancel-title">No worries.</h1>
        <p className="text-navy/70 mt-3">You can upgrade any time. Wholesome works beautifully on the free plan too.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/premium" data-testid="pay-cancel-try" className="btn-pill bg-rose text-white hover:bg-rose-600">Try again</Link>
          <Link to="/app" data-testid="pay-cancel-back" className="btn-pill bg-white/70 border border-navy/10 text-navy">Back to app</Link>
        </div>
      </div>
    </div>
  );
}
